export default state => state.alipayPlus.walletDetails;
